export default "__VITE_ASSET__BkGNO5bo__"